import { ReactNode } from "react";
import { configureStore } from '@reduxjs/toolkit';
import {
    Provider,
    useDispatch,
    useSelector as useAppSelector,
    TypedUseSelectorHook
} from 'react-redux';
import { persistStore, persistReducer } from 'redux-persist';
import { rootPersistConfig, rootReducer } from './rootReducer';
import { dailyPricingListenerMiddleware, loadDailyPrincingAction, DailPricingState } from './slices/dailyPricing';
import { useDailyPricingData, useManagementData } from "src/hooks/useData";
import { loadUserAction, usersListenerMiddleware, UserState } from "./slices/users";
// ----------------------------------------------------------------------
const store = configureStore({
    reducer: persistReducer(rootPersistConfig, rootReducer),
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
            immutableCheck: false,
        }).prepend(dailyPricingListenerMiddleware, usersListenerMiddleware),
});

//const persistor = persistStore(store);

type RootState = ReturnType<typeof rootReducer>;

//type AppDispatch = typeof store.dispatch;

const { dispatch, getState } = store;

const getDailyPricingState = () =>
    getState().dailyPricing as DailPricingState;

const getUserState = () =>
    getState().users as UserState;

//const useDispatch = () => useAppDispatch<AppDispatch>();

const useSelector: TypedUseSelectorHook<RootState> = useAppSelector;

type ReduxProviderProps = {
    children: ReactNode;
};

function ReduxProvider({ children }: ReduxProviderProps) {
    const { getMaterials, getMarkets } = useDailyPricingData();
    const { getApplications, getUsers } = useManagementData();

    loadDailyPrincingAction(getMaterials, getMarkets);
    loadUserAction(getApplications, getUsers);
    
    return (<Provider store={store}>
        {children}
    </Provider>);
}

export { ReduxProvider, dispatch, useSelector, getDailyPricingState, getUserState };

